export const categoryPanelProps = {
    linkType: {
        default: 'blog'
    },
    flatCategoriesShape: {
        default: false,
    },
    category_column: {
        default: 'id'
    },
    activeLatestFilter:{
        default: true,
    }
}